
import { dynamicIconImports } from "lucide-react/dynamic";
import dynamic from "next/dynamic";
import { ComponentType, SVGProps } from "react";

type TIconComponent = ComponentType<SVGProps<SVGSVGElement>>;
type TIconLoader = () => Promise<{ default: TIconComponent }>;

const loadIcon = (
  loader: TIconLoader,
): TIconComponent => dynamic(
  () => loader().then((module) => module.default),
);

export const getLucideIcon = (
  icon: keyof typeof dynamicIconImports,
) => loadIcon(dynamicIconImports[icon]);

export const getCustomIcon = (
  loader: TIconLoader,
) => loadIcon(loader);
